import React, { Component } from 'react';

// Shared utilities
import { CookieService, Utils } from '../../../../shared';
class TaxonomySyncModal extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
        <div className='taxonomySyncModal modal is-active'>
          <div className="modal-content">
            <article className="message">
              <div className="message-header">
                <span>Sync taxonomy discrepancies</span>
              </div>
              <div className="message-body">
                <span className='info-message'>The taxonomy values have been changed and they are not aligned across different sources (items highlighted in red). Please select the value you want to keep as the source of truth.
                  Note: Sync is only possible between Media Ops and MediaOcean! Planit will need to be manually updated in the planning system. <a className='planit-link' href={`https://omni.annalect.com/${Utils.getRouteParam("clientid")}/apps/omg_planit?`} target="_blank">Click here</a> to go to Planit to update.</span>
                {this.props.getTaxonomySyncTable()}
              </div>
              <div className="message-footer">
                <span></span>
                <div className='button-container'>
                  <button className='tertiary' onClick={this.props.cancelTaxonomySyncModal}>Cancel</button>
                  <button disabled={this.props.selectedTaxonomyFromSync === ''} onClick={this.props.keepSelectedTaxonomyFromSync}>Keep selected taxonomy</button>
                </div>
              </div>
            </article>
          </div>
        </div>
    );
  }
}
export default TaxonomySyncModal;